/**
 * PWA-4 — non-durable queue storage.
 *
 * Two uses: unit tests, and a runtime fallback when IndexedDB is unavailable
 * (Safari private browsing, locked-down enterprise profiles). The fallback loses
 * the queue on reload, which is strictly worse than IndexedDB but strictly
 * better than the action failing outright — and it keeps every call site free of
 * "is storage available" branching.
 */

import type { QueuedAction, SyncQueueStorage } from './types';

export function createMemoryStorage(seed: QueuedAction[] = []): SyncQueueStorage {
  const items = new Map<string, QueuedAction>(seed.map((a) => [a.id, a]));
  return {
    async list() {
      return [...items.values()];
    },
    async put(action) {
      items.set(action.id, action);
    },
    async remove(id) {
      items.delete(id);
    },
    async clear() {
      items.clear();
    },
  };
}
